import { api } from "./base";
// API для поддержки (заглушка, так как в оригинале файл пустой)
export const sendSupportMessage = async (data) => {
    const response = await api.post("/support/", data);
    return response.data;
};
// Идентифицирующий токен для deep-link в бота поддержки: по нему Omnidesk
// определяет, какой залогиненный веб-юзер написал в бот. Куки-авторизация
// уезжает через withCredentials axios-инстанса.
export const requestSupportToken = async () => {
    const response = await api.post("/api/v1/public/support/token");
    return response.data;
};
